<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <v-app>
    <AppBar v-model="drawer" />
    <v-navigation-drawer v-model="drawer">
      <v-list nav>
        <v-list-item
          to="/"
          @click="drawer = false"
        >
          Home
        </v-list-item>
        <v-list-item
          to="/faq"
          @click="drawer = false"
        >
          FAQ
        </v-list-item>
        <v-list-item
          to="/carriers"
          @click="drawer = false"
        >
          Carriers
        </v-list-item>
        <v-list-item
          to="/shipping-guide"
          @click="drawer = false"
        >
          Shipping Guide
        </v-list-item>
        <v-list-item
          to="/devices"
          @click="drawer = false"
        >
          Devices
        </v-list-item>
        <v-divider class="my-2" />
        <v-list-item
          to="/code"
          @click="drawer = false"
        >
          Subscribe
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { useAppStore } from '@/stores/app'

  const appStore = useAppStore()
  const { page } = storeToRefs(appStore)
  const drawer = ref(false)
</script>

<style lang="css">
  main {
    background-color: rgb(247, 242, 226);
  }
</style>
